// jsonLogic predicate evaluator — same dialect as
// apps/portal/src/signup/lib/branching.ts:42–96 so admins can author the
// same expressions for branch routing and per-block visibility without
// learning two languages. We duplicate the implementation here rather
// than importing from the portal because the package compiles
// independently (used by both portal and, in the future, install SPA).
//
// Supported operators (intentionally a strict subset of jsonlogic):
//   { var: "contact.email" }                       — read a dotted path
//   { ==: [a, b] } / { !=: [a, b] }                — strict (in)equality
//   { in: [a, [b, c]] }                            — array membership
//   { and: [r1, r2, ...] } / { or: [...] }         — boolean composition
//   { !: r }                                       — negation
//   { empty: r } / { !empty: r }                   — null/undefined/'' checks
// Literals pass through unchanged.
function getPath(payload, path) {
    return path.split('.').reduce((acc, key) => {
        if (acc && typeof acc === 'object' && key in acc) {
            return acc[key];
        }
        return undefined;
    }, payload);
}
export function evaluateVisibility(rule, payload) {
    if (rule === null || rule === undefined)
        return rule;
    if (typeof rule !== 'object')
        return rule;
    if (Array.isArray(rule))
        return rule.map((r) => evaluateVisibility(r, payload));
    const entries = Object.entries(rule);
    if (entries.length !== 1)
        return rule;
    const [op, raw] = entries[0];
    const args = Array.isArray(raw)
        ? raw.map((a) => evaluateVisibility(a, payload))
        : evaluateVisibility(raw, payload);
    switch (op) {
        case 'var':
            return getPath(payload, String(args));
        case '==':
            return Array.isArray(args) && args[0] === args[1];
        case '!=':
            return Array.isArray(args) && args[0] !== args[1];
        case 'in':
            return (Array.isArray(args) &&
                Array.isArray(args[1]) &&
                args[1].includes(args[0]));
        case 'and':
            return Array.isArray(args) && args.every(Boolean);
        case 'or':
            return Array.isArray(args) && args.some(Boolean);
        case '!':
            return !args;
        case 'empty':
            return args === null || args === undefined || args === '';
        case '!empty':
            return !(args === null || args === undefined || args === '');
        default:
            return undefined;
    }
}
/**
 * Convenience wrapper for the common boolean case — when `__visibility`
 * is absent, treat the block as visible.
 */
export function isVisible(rule, payload) {
    if (rule === undefined)
        return true;
    return Boolean(evaluateVisibility(rule, payload));
}
